import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment.prod';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  assetsUrl = environment.baseAssetsUrl; 


  constructor(private router: Router ) { }

  ngOnInit() {
  }

  goToHomepage() {
    this.router.navigate(['/inicio']);
    localStorage.removeItem('token_reset_password');
    localStorage.removeItem('token_password_complaint');
  }

}
